import React from 'react';
import PropTypes from 'prop-types';
import { PSPSection } from 'components/molecules/PSPSection';
import { Section } from 'components/core/Page';
import { StickySearch } from '../StickySearch/StickySearch';
import './PSPLayout.scss';
import BreadCrumbs from '../../molecules/BreadCrumbs/BreadCrumbs';

function PSPLayout({
	content,
	pageSchema,
	pageType,
	handleSearch,
	breadcrumbUrl,
}) {
	const { sections, type } = content;

	const triggerId =
		type === 'CubeSmart'
			? 'find-cubesmart-self-storage'
			: `psp-${pageType === 'size-guide' ? 'search-bar' : 'hero'}-sticky-search`;

	let label = '';

	switch (content.pageType) {
		case 'SGP':
			label = type
				.split('-')
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');
			break;
		default:
			if (type && !type.toLowerCase().includes('electricity')) {
				const base = type
					.replace(/\s*\b(self\s+)?storage\b\s*/gi, ' ')
					.replace(/^\s*self\s*$/i, '')
					.trim();
				label = base ? `${base} Self Storage` : 'Self Storage';
			} else if (type && type.toLowerCase().includes('electricity')) {
				label = `Self Storage with Electricity`;
			}
	}

	const pspSgpBreadCrumbs = [
		{ key: 'crumb-home', label: 'Home', href: '/' },
		...(content.pageType === 'SGP'
			? [
					{
						key: 'crumb-size-guide',
						label: 'Size Guide',
						href: '/self-storage-sizes/',
					},
					{ key: 'crumb-type', label, href: breadcrumbUrl || '' },
				]
			: [{ key: 'crumb-type', label, href: breadcrumbUrl || '' }]),
	];

	return (
		<div
			className={`${pageType} ${content.pageType === 'SGP' ? 'sgp-layout' : 'psp-layout'}`}
		>
			<div className="page-container">
				<BreadCrumbs pspSgpBreadCrumbs={pspSgpBreadCrumbs} />
			</div>
			<StickySearch
				handleSearch={handleSearch}
				triggerId={triggerId}
			/>
			<Section className="psp-body">
				{sections.map((section, index) => (
					<PSPSection
						{...section}
						pageType={content.pageType}
						// eslint-disable-next-line react/no-array-index-key
						key={`${section.title}-${index}`}
					/>
				))}
			</Section>

			<script
				key="schema"
				type="application/ld+json"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: pageSchema }}
			/>
		</div>
	);
}

PSPLayout.propTypes = {
	pageSchema: PropTypes.string,
	content: PropTypes.object,
	handleSearch: PropTypes.func,
	storageCalculatorUrl: PropTypes.string,
	disableJumpSection: PropTypes.bool,
	pageType: PropTypes.string,
	breadcrumbUrl: PropTypes.string,
};

PSPLayout.defaultProps = {
	storageCalculatorUrl: '',
};

export default PSPLayout;
